import momenttz from 'moment-timezone';
// import { data } from '../../Mock/TargetsAssociate/index';

import Api from 'Shared/Services/Api/index';
import GetSystemAuthUtil from 'Shared/Utils/ConfigEnvironment/GetSystemAuth/index';
import { ITargetsAssociate, ITargetsAssociateFilters, ITargetsAssociateResponse } from 'Module/SuppliersReport/Interface';

const validFilters = (element: ITargetsAssociate, filters: ITargetsAssociateFilters, isPrincipal: boolean) => {
  let isFilter = true
  if (filters.codigo && element.codigo !== filters.codigo) {
    isFilter = false
  }
  if (filters.documento && element.documento !== filters.documento) {
    isFilter = false
  }
  if (filters.nome && !element.nome?.includes(filters.nome)) {
    isFilter = false
  }

  if (isPrincipal && filters.codigoFornec && element.codFornecPrinc !== filters.codigoFornec) {
    isFilter = false
  }
  if (!isPrincipal && filters.codigoFornec && element.codigoFornec !== filters.codigoFornec) {
    isFilter = false
  }

  return isFilter;
}

const toNumber = (value: any) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const formatIntegerPad = (value: number) =>
  Number(value).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).padStart(4, '0');

const formatCurrency = (value: number) =>
  Number(value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const formatPercent = (value: number) =>
  Number(value).toLocaleString("pt-BR", { minimumIntegerDigits: 2, minimumFractionDigits: 2, maximumFractionDigits: 2 });


export const getTargetsAssociateService = async (params: ITargetsAssociateFilters, isPrincipal: boolean) => {
  return new Promise<ITargetsAssociateResponse>(async (resolve, reject) => {
    let _arrayReg: [ITargetsAssociate?] = [];
    let regReturn: ITargetsAssociateResponse = {
      status: '200',
      message: '',
    };

    try {
      let _url = params.codigoFornec ? isPrincipal ? `/metabyfornecedorprincipal/${Number(params.codigoFornec).toString()}` : `/metabyfornecedor/${Number(params.codigoFornec).toString()}` :
        params.codigo ? `/metabyassociado/${Number(params.codigo).toString()}` : '/meta';
      let _config = {
        "systemauth": GetSystemAuthUtil(process.env.REACT_APP_ENVIRONMENT)
      };
      const shouldGroupByCodigo = Boolean(params.codigoFornec) && isPrincipal;
      await Api.get(_url, { params: _config })
        .then(resp => {
          if (resp.data.data && resp.data.data.length > 0) {
            const groupedByCodigo = new Map<string, {
              base: ITargetsAssociate;
              metaMixValue: number;
              mixValue: number;
              metaFaturamentoTotal: number;
              faturamentoTotal: number;
            }>();

            for (let reg of resp.data.data) {
              const metaMixValue = toNumber(shouldGroupByCodigo ? reg.metaMixFornPrincipal?.value : reg.metaMix.value);
              const mixValue = toNumber(shouldGroupByCodigo ? reg.mixFornPrincipal?.value : reg.mix.value);
              const metaFaturamentoValue = toNumber(reg.metaFaturamento.value);
              const faturamentoValue = toNumber(reg.faturamento.value);

              const _item = {
                id: reg.guidcontrol.value,
                codigo: reg.codigo.value ? reg.codigo.value.padStart(4, '0') : '0000',
                nome: reg.nome.value,
                documento: reg.documento.value,
                codigoFornec: reg.codigoFornec.value ? reg.codigoFornec.value.padStart(6, '0') : '000000',
                documentFornec: reg.documentFornec.value,
                nomeFornec: reg.nomeFornec.value,
                codClientePrinc: reg.codClientePrinc.value ? reg.codClientePrinc.value.padStart(4, '0') : '0000',
                codFornecPrinc: reg.codFornecPrinc.value ? reg.codFornecPrinc.value.padStart(6, '0') : '000000',
                valorBase: formatCurrency(toNumber(reg.valorBase.value)),
                qtdeBase: formatCurrency(toNumber(reg.qtdeBase.value)),
                metaMix: formatIntegerPad(metaMixValue),
                mix: formatIntegerPad(mixValue),
                percentMix: formatPercent(metaMixValue ? (mixValue / metaMixValue) * 100 : 0),

                metaFaturamento: formatCurrency(metaFaturamentoValue),
                faturamento: formatCurrency(faturamentoValue),
                percentFaturmento: formatPercent(metaFaturamentoValue ? (faturamentoValue / metaFaturamentoValue) * 100 : 0),
                criadoEm: momenttz(reg.criadoEm.value).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm'),
                alteradoEm: momenttz(reg.alteradoEm.value).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm'),
              }

              if (shouldGroupByCodigo) {
                const groupKey = _item.codigo || '';
                const existing = groupedByCodigo.get(groupKey);
                if (!existing) {
                  groupedByCodigo.set(groupKey, {
                    base: _item,
                    metaMixValue,
                    mixValue,
                    metaFaturamentoTotal: metaFaturamentoValue,
                    faturamentoTotal: faturamentoValue,
                  });
                } else {
                  existing.metaFaturamentoTotal += metaFaturamentoValue;
                  existing.faturamentoTotal += faturamentoValue;
                }
              } else if (validFilters(_item, params, isPrincipal)) {
                _arrayReg.push(_item);
              }
            }

            if (shouldGroupByCodigo) {
              groupedByCodigo.forEach((groupItem) => {
                const percentMix = groupItem.metaMixValue
                  ? (groupItem.mixValue / groupItem.metaMixValue) * 100
                  : 0;
                const percentFaturmento = groupItem.metaFaturamentoTotal
                  ? (groupItem.faturamentoTotal / groupItem.metaFaturamentoTotal) * 100
                  : 0;

                const mergedItem = {
                  ...groupItem.base,
                  metaMix: formatIntegerPad(groupItem.metaMixValue),
                  mix: formatIntegerPad(groupItem.mixValue),
                  percentMix: formatPercent(percentMix),
                  metaFaturamento: formatCurrency(groupItem.metaFaturamentoTotal),
                  faturamento: formatCurrency(groupItem.faturamentoTotal),
                  percentFaturmento: formatPercent(percentFaturmento),
                };

                if (validFilters(mergedItem, params, isPrincipal)) {
                  _arrayReg.push(mergedItem);
                }
              });
            }
          }

          regReturn.list = _arrayReg;
          resolve(regReturn);
        })
        .catch(error => {
          console.log(error);
          let msgerror = error.stack ? error.stack : 'Ocorreu um erro!';
          if (error.response && error.response.data) {
            msgerror = error.response.data.msgErr;
          }
          if (error.response && error.response.result) {
            msgerror = error.response.result.msgErr;
          }

          regReturn.status = '400';
          regReturn.message = msgerror;
          regReturn.msgErro = JSON.stringify(error);
          reject(regReturn)
        });
    }
    catch (err) {
      console.log('AssociatesReport.Service.getAll.err');
      console.log(err);

      let _msgError = 'Ocorreu um erro!';
      regReturn.status = '400';
      regReturn.message = _msgError;
      regReturn.msgErro = JSON.stringify(err);
      reject(regReturn)
    }
  });
}
